import "../style.css";
import Past from "../past";

export default function PMHx() {
  return <Past past="medical" />;
}
